<h3 class="app-form-section-heading mt0 mb3">
  {{ 'DOCUMENT_FORM_SECTION.DOCUMENTS_TO_SIGN' | translate }}
</h3>

<div [formGroup]="formGroup">
  <ngx-dropzone
    *ngIf="canUploadFiles"
    class="app-file-dropzone"
    [class.mb3]="documentsData.length"
    (change)="documentsSelected.emit($event.addedFiles)"
  >
    <ngx-dropzone-label
      >{{ 'DOCUMENT_FORM_SECTION.INSERT_FILE.PART1' | translate }}
      <lib-button weight="tertiary" [slim]="true">{{
        'DOCUMENT_FORM_SECTION.INSERT_FILE.PART2' | translate
      }}</lib-button>
    </ngx-dropzone-label>
  </ngx-dropzone>

  <div *ngIf="documentsData.length" class="pt1 mb2">
    <h4 class="mt0 mb2 font-medium regular flex items-center justify-between">
      <div>
        {{
          'DOCUMENT_FORM_SECTION.DOCUMENT_LIST'
            | translate
              : {
                  count: documentsData.length
                }
        }}
      </div>

      <div class="app-documents-controls flex flex-column items-end">
        <div *ngIf="canSelectDefaultSigType" class="flex items-center font-normal">
          <div class="mr1">
            {{ 'DOCUMENT_FORM_SECTION.DEFAULT_SIGNATURE_TYPE.TITLE' | translate }}
          </div>
          <lib-hint
            [text]="'DOCUMENT_FORM_SECTION.DEFAULT_SIGNATURE_TYPE.HINT' | translate"
            class="mr2"
          ></lib-hint>
          <app-signature-type-select
            [value]="transactionBuilderStorage.getDefaultSignatureType()"
            (typeSelect)="onDefaultSigTypeSelect($event)"
          ></app-signature-type-select>
        </div>

        <div *ngIf="canSelectGlobalSigType" class="flex items-center font-normal">
          <div class="mr1">{{ 'DOCUMENT_FORM_SECTION.SIGNATURE_TYPE' | translate }}</div>
          <lib-hint
            [text]="'DOCUMENT_FORM_SECTION.SIGNATURE_TYPE.HINT' | translate"
            class="mr2"
          ></lib-hint>
          <app-signature-type-select
            [value]="signFieldsByDocument | collectiveDocsSignatureType"
            (typeSelect)="onGlobalSigTypeSelect($event)"
          ></app-signature-type-select>
        </div>
      </div>
    </h4>

    <app-document-card
      *ngFor="let documentData of documentsData; index as i"
      [class.mb3]="i < documentsData.length - 1"
      [formArray]="clientsToDocsFormArray.controls[i]"
      [documentName]="documentData.name"
      [clients]="clients"
      [signFields]="signFieldsByDocument[documentData.cid]"
      [canRemoveFile]="canRemoveFiles"
      [canEditDocSigners]="canEditDocSigners"
      (editSignFields)="editSignFields.emit({ documentData: documentData, client: $event })"
      (removeDocument)="removeDocument.emit({ documentData: documentData, index: i })"
      (documentSwap)="onDocumentSwap($event, documentData.cid)"
    ></app-document-card>
  </div>
</div>
